/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-03-27 10:37:57
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\cookie\cookie.js
 * @
 */
import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const Permission = 'Admin-Permission'
const Menu = 'Menu'
//递归遍历获取所有权限id
var findInObject = function (dataObj, key) {
    let arr = []
    if (typeof dataObj !== 'object') return arr
    for (let prop in dataObj) {
        if (prop == key) {
            arr.push(dataObj[key])
        } else {
            if (Array.isArray(dataObj[prop])) {
                dataObj[prop].forEach((item) => {
                    arr = arr.concat(findInObject(item, key))
                })
            }
        }
    }
    return arr
}

//存储Token到cookie
export function setToken(value) {
    return Cookies.set(TokenKey, value)
}

//从cookie获取Token
export function getToken() {
    return Cookies.get(TokenKey)
}

//从cookie删除Token
export function removeToken() {
    Cookies.remove(TokenKey)
}

//存储用户权限菜单
export function setMenu(value) {
    const sonId = findInObject(value, 'sonId')
    return Cookies.set(Menu, sonId)
}

//获取用户权限菜单
export function getMenu() {
    if (Cookies.get(Menu)) {
        return JSON.parse(Cookies.get(Menu))
    }
}

//用户注销删除用户权限菜单
export function removeMenu() {
    Cookies.remove(Menu)
}

//获取用户权限存储
export function setPermission(value) {
    const sonId = findInObject(value, 'functionId')

    return Cookies.set(Permission, sonId)
}
//获取用户权限
export function getPermission() {
    if (Cookies.get(Permission)) {
        return JSON.parse(Cookies.get(Permission))
    }
}
//清除用户权限
export function removePermission() {
    Cookies.remove(Permission)
}
//清除gateonecookie
export function remgateone() {
    Cookies.remove('gateone_user')
}


export function SetDeviceIp(v) {
    Cookies.set('device_ip', v)
}

export function removeWebCookie() {
    Cookies.remove('sysauth_http')
    Cookies.remove('device_ip')
    Cookies.remove('device_port')
}

export function SetDevicePort(v) {
    Cookies.set('device_port', v)
}